export const styles = {
  textFieldContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 4,
    alignSelf: 'stretch',
    width: '100%',
  } as React.CSSProperties,
  textFieldTopTextContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
    alignItems: 'center',
    gap: 4,
  } as React.CSSProperties,
  textFieldLabelContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: 4,
  } as React.CSSProperties,
  textFieldLeadingIcon: {
    position: 'absolute',
    left: 12,
    top: 7,
    width: 24,
    height: 24,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    zIndex: 99,
  } as React.CSSProperties,
  textFieldInput: {
    width: '100%',
    borderWidth: 1,
    borderRadius: 8,
    padding: '8px 12px',
    outlineWidth: 1,
    margin: 0,
    boxSizing: 'border-box',
    position: 'relative',
  } as React.CSSProperties,
  textFieldTrailingIcon: {
    position: 'absolute',
    right: 12,
    top: 7,
    width: 24,
    height: 24,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 99,
    cursor: 'pointer',
  } as React.CSSProperties,
};
